module.exports = __webpack_public_path__ + "static/media/13.f1e5637e.jpg";